export default __webpack_public_path__ + "static/media/loading-gif.3bd80a05.gif";